import { addProjectRole, updateProjectRole } from '@/services/role/role'
import { ProjectRole } from '@/services/role/role.model'
import { useRequest } from 'ahooks'
import { Checkbox, Col, Divider, Form, Input, Modal, ModalProps, Row, Space, Typography } from 'antd'
import { useEffect, useState } from 'react'
import ReactDOM from 'react-dom'

interface AddEditRoleModalProps extends ModalProps {
  projectType: string
  projectId: number
  onSuccess: () => void
  role?: ProjectRole
}

function AddEditRoleModal(props: AddEditRoleModalProps) {
  const { projectType, projectId, role, onSuccess, onCancel } = props
  const [visible, setVisible] = useState(true)
  const [form] = Form.useForm()
  const { loading, run } = useRequest(
    (values) => {
      if (role) {
        return updateProjectRole(projectType, projectId, role.id, values)
      } else {
        return addProjectRole(projectType, projectId, values)
      }
    },
    {
      manual: true,
      onSuccess: () => {
        handleCancel()
        onSuccess()
      }
    }
  )

  const handleCancel = (e?) => {
    setVisible(false)
    onCancel?.(e)
  }

  useEffect(() => {
    if (role) {
      form.setFieldsValue(role)
    }
  }, [])

  return (
    <Modal
      {...props}
      width={600}
      visible={visible}
      onCancel={handleCancel}
      confirmLoading={loading}
      onOk={() => form.submit()}
    >
      <Form
        form={form}
        onFinish={(values) => {
          console.log(values)
          run({ ...values, permissions: [] })
        }}
      >
        <Form.Item label='Name' name='name' rules={[{ required: true, message: 'Please enter role name' }]}>
          <Input type='text' />
        </Form.Item>

        <Divider />

        <Typography.Title level={5}>Permission (TBD)</Typography.Title>

        <Form.Item noStyle>
          <Space direction='vertical' size='middle' style={{ display: 'flex' }}>
            <span>ODM RD data</span>
            <Checkbox.Group style={{ width: '100%' }} defaultValue={['read']}>
              <Row>
                <Col span={8}>
                  <Checkbox value='read' disabled>
                    Read
                  </Checkbox>
                </Col>
                <Col span={8}>
                  <Checkbox value='write' disabled>
                    Write
                  </Checkbox>
                </Col>
              </Row>
            </Checkbox.Group>

            <span>Features</span>

            <Checkbox.Group style={{ width: '100%' }} defaultValue={['settingPage']}>
              <Row>
                <Col span={8}>
                  <Checkbox value='settingPage' disabled>
                    Setting page
                  </Checkbox>
                </Col>
                <Col span={8}>
                  <Checkbox value='projectBook' disabled>
                    Project book
                  </Checkbox>
                </Col>
              </Row>
            </Checkbox.Group>
          </Space>
        </Form.Item>
      </Form>
    </Modal>
  )
}

AddEditRoleModal.show = (props: AddEditRoleModalProps) => {
  const div = document.createElement('div')
  document.body.appendChild(div)
  const clean = () => {
    ReactDOM.unmountComponentAtNode(div)
    div.remove()
  }

  ReactDOM.render(
    <AddEditRoleModal
      {...props}
      onCancel={(e) => {
        props.onCancel?.(e)
        clean()
      }}
    />,
    div
  )
}

export default AddEditRoleModal
